import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "JobCredential/";

const getJobCredentials = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobCredentials?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const deleteJobCredential = async (jobCredentialId, jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteJobCredential?id=' + jobCredentialId + '&jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const saveJobCredentials = async (jobs) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveJobCredentials', jobs, constants.REQUIRE_INTERCEPTORS);

export {
    getJobCredentials,
    deleteJobCredential,
    saveJobCredentials
}